import React, { useEffect, useRef } from 'react';
import { MultiStepModal } from '@/components/ui/multi-step-modal';
import { useOnboarding } from '../hooks/use-onboarding';
import { WelcomeScreen } from '../screens/welcome-screen';
import { PermissionsScreen } from '../screens/permissions-screen';
import { IntentCaptureScreen } from '../screens/intent-capture-screen';
import { TastePreferencesScreen } from '../screens/taste-preferences-screen';
import { FriendSeedingScreen } from '../screens/friend-seeding-screen';
import { CompletionScreen } from '../screens/completion-screen';

const TOTAL_STEPS = 6;

export function OnboardingGate() {
  const onboarding = useOnboarding();
  const hasStartedRef = useRef(false);

  useEffect(() => {
    if (onboarding.status === 'required' && !hasStartedRef.current) {
      hasStartedRef.current = true;
      onboarding.start();
    }
  }, [onboarding.status]);

  if (onboarding.status !== 'required') {
    return null;
  }

  const renderStep = () => {
    switch (onboarding.currentStep) {
      case 1:
        return <WelcomeScreen onNext={onboarding.nextStep} isAdvancing={onboarding.isAdvancing} />;
      case 2:
        return <PermissionsScreen onNext={onboarding.nextStep} isAdvancing={onboarding.isAdvancing} />;
      case 3:
        return (
          <IntentCaptureScreen
            onSelect={onboarding.setIntent}
            onNext={onboarding.nextStep}
            selectedIntent={onboarding.payload.intent}
            isAdvancing={onboarding.isAdvancing}
          />
        );
      case 4:
        return (
          <TastePreferencesScreen
            onSave={onboarding.setTastePreferences}
            onNext={onboarding.nextStep}
            initialCuisines={onboarding.payload.taste_preferences?.cuisines ?? []}
            initialRestrictions={onboarding.payload.taste_preferences?.dietary_restrictions ?? []}
            isAdvancing={onboarding.isAdvancing}
          />
        );
      case 5:
        return (
          <FriendSeedingScreen
            onSkip={() => {
              onboarding.skipFriendSeeding();
              onboarding.nextStep();
            }}
            onNext={onboarding.nextStep}
            isAdvancing={onboarding.isAdvancing}
          />
        );
      case 6:
        return <CompletionScreen onComplete={onboarding.complete} isAdvancing={onboarding.isAdvancing} />;
      default:
        return null;
    }
  };

  return (
    <MultiStepModal
      visible={true}
      currentStep={onboarding.currentStep}
      totalSteps={TOTAL_STEPS}
      onBack={onboarding.currentStep > 1 ? onboarding.goBack : undefined}
      canGoBack={onboarding.currentStep > 1}
      testID="onboarding-modal"
    >
      {renderStep()}
    </MultiStepModal>
  );
}
